import { z } from "zod";

/**
 * Growth Engine reuses the WanderFitness Firebase project for identity (ADR-0016):
 * the same Firebase config as wanderfit-app/backoffice, but role + tenant are
 * resolved from OUR API (`GET /api/auth/me`), never from Firebase custom claims.
 */
const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_API_BASE_URL: z.string().url(),
  VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("Invalid environment configuration:", parsed.error.flatten().fieldErrors);
  throw new Error("Missing or invalid environment variables. See .env.example.");
}

export const env = parsed.data;
